import React from "react";
import { Spinner } from "react-bootstrap";
import { useIsFetching } from "react-query";
import styles from "./Common.module.css";

function GlobalLoadingIndicator() {
  const isFetching = useIsFetching();

  return isFetching ? (
    <Spinner
      animation="border"
      className={["position-absolute  text-primary m-2", styles.spinner]}
    />
  ) : null;
}
export default GlobalLoadingIndicator;
